module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sceneIsReady ? 'show' : 'hide',
    attrs: {
      "id": "renderer"
    }
  }, [_c('a-scene', {
    attrs: {
      "antialias": "true"
    }
  }, [_c('assets'), _vm._v(" "), _vm._l((_vm.visibleTweets), function(tweet) {
    return _c('tweet', {
      key: tweet.id,
      attrs: {
        "position": tweet.position,
        "tweet": tweet
      }
    })
  }), _vm._v(" "), _vm._l((_vm.visibleFrames), function(frame) {
    return _c('frame', {
      key: frame.id,
      attrs: {
        "id": frame.id,
        "position": frame.position,
        "rotation": frame.rotation
      }
    })
  }), _vm._v(" "), _c('camera', {
    attrs: {
      "position": _vm.camera.position,
      "controls-enabled": _vm.controlsEnabled
    }
  }), _vm._v(" "), _c('light', {
    attrs: {
      "position": _vm.camera.position
    }
  }), _vm._v(" "), _c('a-gradient-sky', {
    attrs: {
      "material": "shader: gradient; topColor: 2 25 65; bottomColor: 2 20 50;"
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f6b35ba!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Renderer.vue
// module id = 182
// module chunks = 2